import { faUserAstronaut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  StyledActions,
  StyledCta
} from 'components/marketingSite/shared/Cta.styled';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading3 } from 'components/shared/Typography';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext } from 'react';
import ServiceEventTracking from 'services/service.event-tracking';
import styled from 'styled-components';
import { container, spacing } from 'theme';
import { APP_URLS, getAppUrl } from 'utils/app-urls';

const StyledCtaBorder = styled(StyledCta)`
  background-color: #d3d9f3;
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('xl4')};
  padding-left: ${spacing('xl5')};
  padding-right: ${spacing('xl5')};

  width: 100%;
  height: 100%;
  object-fit: cover;
  text-align: left;

  mask-image: url('/images/blog/irregular-box-white.svg');
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center;

  -webkit-mask-image: url('/images/blog/irregular-box-white.svg');
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;

  color: #0a053a;
`;
const StyledButtonLink = styled(ButtonLink)`
  width: max-content;
  white-space: nowrap;
  flex: 0 0 auto;
  margin-top: 0;
`;

const StyledActionsBorder = styled(StyledActions)`
  justify-content: left;
  max-width: ${container('xs')};
  margin-top: ${spacing('md')};
`;

const BlogCta: React.FC = () => {
  const { t } = useI18n('blog');
  const { locale } = useRouter();

  const { user, loadingUser } = useContext(LoggedUserContext);

  if (user || loadingUser) {
    return null;
  }

  return (
    <StyledCtaBorder>
      <Heading3>{t('cta.title')}</Heading3>
      <div
        dangerouslySetInnerHTML={{
          __html: t('cta.desc')
        }}
      ></div>
      <StyledActionsBorder>
        <Link
          href={`${getAppUrl(
            APP_URLS.join,
            locale
          )}?locale=${locale}&source=footer-blog`}
          passHref
        >
          <StyledButtonLink
            variant="blogCompany"
            sizes="md"
            onClick={(e) =>
              ServiceEventTracking.trackExternalLandingCtaClicked(
                e,
                `${getAppUrl(
                  APP_URLS.join,
                  locale
                )}?locale=${locale}&source=footer-blog`,
                'footer-blog'
              )
            }
          >
            <FontAwesomeIcon icon={faUserAstronaut} />
            <span>{t('cta.action')}</span>
          </StyledButtonLink>
        </Link>
      </StyledActionsBorder>
    </StyledCtaBorder>
  );
};

export default BlogCta;
